import { render, staticRenderFns } from "./Exams.vue?vue&type=template&id=50313d22&scoped=true"
import script from "./Exams.vue?vue&type=script&lang=js"
export * from "./Exams.vue?vue&type=script&lang=js"
import style0 from "./Exams.vue?vue&type=style&index=0&id=50313d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50313d22",
  null
  
)

export default component.exports